import React from 'react';
import { Box } from 'grommet'
import ContactForm from '../components/ContactForm'

const Contact = () => {
  return <Box
      direction="row"
      align="center"
      margin="0px"
      flex="grow"
      className="indexContainer"
      animation={["fadeIn", "slideUp"]}
    >
      <div className="indexHero pageHero contactHero">
        <h1>Contact Me</h1>
        <ContactForm />
      </div>
    </Box>
};

export default Contact;
